<template>
  <div class="block">
    <label>{{ title }}</label>
    <el-date-picker
        v-model="value"
        type="daterange"
        unlink-panels
        range-separator="-"
        :start-placeholder="startTime"
        :end-placeholder="endTime"
        :shortcuts="shortcuts"
        :default-value="defaultValue"
        :disabled="checked"
        value-format="YYYY-MM-DD"
        @change="postTime"
        style="width: 18em"
    >
    </el-date-picker>
    <el-checkbox
        v-model="checked"
        :checked="isChecked"
        @change="noTime()"
        style="margin-left: 8px;"
    >
      不限
    </el-checkbox>
  </div>
</template>

<script>
export default {
name: "date-picker",
  props: {
    title: {
      type: String,
      default: '时间：'
    },
    isChecked: {
      type: Boolean,
      default: true,
    },
    isAddOneDay:{
      type: Boolean,
      default: true
    },
    startTime:{
      type: String,
      default: function() {
        let d = new Date();
        d.setDate(d.getDate()-7);
        return d.getFullYear()+"-"+(d.getMonth()+1 < 10?'0'+(d.getMonth()+1):d.getMonth()+1)+"-"+(d.getDate() < 10?'0'+d.getDate():d.getDate());
      }
    },
    endTime:{
      type: String,
      default: function() {
        let d = new Date();
        d.setDate(d.getDate());
        return d.getFullYear()+"-"+(d.getMonth()+1 < 10?'0'+(d.getMonth()+1):d.getMonth()+1)+"-"+(d.getDate() < 10?'0'+d.getDate():d.getDate());
      }
    },
  },
  data() {
    return {
      checked: this.isChecked,
      value: [],
      defaultValue: new Date(),
      shortcuts: [
        {
          text: '最近一周',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
          },
        },
        {
          text: '最近一个月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
          },
        },
        {
          text: '最近三个月',
          value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
          },
        },
      ]
    }
  },
  watch: {
    isChecked() {
      this.checked = this.isChecked
      this.value[0] = this.startTime;
      this.value[1] = this.endTime;
      if(!this.checked) {
        this.$emit('date', [this.value[0],this.value[1]]);
      } else {
        this.$emit('date', [null, null]);
      }
    }
  },
  methods: {
    postTime() {
      this.$emit('date', [this.value[0],this.value[1]]);
    },
    noTime() {
      if(this.checked){
        this.$emit('date', [null, null]);
      }else{
        this.$emit('date', [this.value[0],this.value[1]]);
      }
      this.$emit('check', this.checked)
    },
    //结束日期加一
    addOneDay(day) {
      let d = new Date(day);
      if(this.isAddOneDay) {
        d.setDate(d.getDate()+1);
      } else {
        d.setDate(d.getDate());
      }
      return d.getFullYear()+"-"+(d.getMonth()+1 < 10?'0'+(d.getMonth()+1):d.getMonth()+1)+"-"+(d.getDate() < 10?'0'+d.getDate():d.getDate());
    }
  },
  created() {
    this.value[0] = this.startTime;
    this.value[1] = this.endTime;
    if(!this.checked) {
      this.$emit('date', [this.value[0],this.value[1]]);
    } else {
      this.$emit('date', [null, null]);
    }

  }
}
</script>

<style scoped>

</style>
